<div class="modal-close" (click)="closeDrawer()">
  <i class="feather x"></i>
</div>

<div class="drawer-content">
  @if (!isForClientDetails) {
    <div class="header">
      <div class="user">
        @if (!isForContact) {
          <img
            class="avatar"
            style="width: 40px; height: 40px"
            [src]="userOrContactDrawer?.user?.pictureUrl"
          />
        }
        <div class="name-and-email">
          <p>
            {{
              !isForContact
                ? userOrContactDrawer?.user?.full_name
                : userOrContactDrawer.name
            }}
          </p>
          <span>{{
            !isForContact
              ? userOrContactDrawer?.user?.email
              : userOrContactDrawer.email
          }}</span>
        </div>
      </div>
      @if (isForContact) {
        <button
          (click)="inviteContactToBecomeClient()"
          class="btn btn-primary add-button"
        >
          <i class="feather user-plus"></i>
          <span>Invite as user</span>
        </button>
      }
      <div
        class="actions"
        dropdown
        dropdownToggle
        placement="bottom right"
        [autoClose]="true"
        [insideClick]="true"
      >
        <i class="feather more-horizontal"></i>
        <ul
          id="dropdown-basic"
          *dropdownMenu
          class="dropdown-menu dropdown-menu-right"
          role="menu"
          aria-labelledby="button-basic"
        >
          <li role="menuitem">
            <a
              (click)="
                !isForContact
                  ? removeClientUser(userOrContactDrawer?.user)
                  : removeContact(userOrContactDrawer?.uuid)
              "
              class="dropdown-item"
              >Remove</a
            >
          </li>
        </ul>
      </div>
    </div>
    @if (!isForContact) {
      <div class="info-section">
        <h3>Info</h3>
        <div class="status-and-2fa">
          <div>
            <span>Status</span>
            <p>
              <i class="feather check" style="color: rgb(28, 211, 28)"></i>
              {{ userOrContactDrawer?.user ? "Joined" : "" }}
            </p>
          </div>
          <div>
            <span>2FA Enabled?</span>
            <p>
              {{ userOrContactDrawer?.is_2fa_enabled ? "Enabled" : "Disabled" }}
            </p>
          </div>
        </div>
      </div>
    }
    <div class="main-section">
      <h3>Details</h3>
      <div class="fields-container">
        @for (
          data_field of userOrContactDrawer?.data_field_values;
          track data_field
        ) {
          <div class="field">
            <span>{{ data_field?.field?.name }}</span>
            @if (
              data_field?.field?.type !== "date" &&
              data_field?.field?.type !== "list" &&
              data_field?.field.type !== "boolean" &&
              data_field?.field?.type !== "number"
            ) {
              <input
                type="text"
                [readonly]="
                  !isForContact && data_field?.field?.key == 'primary_email'
                    ? true
                    : false
                "
                pInputText
                class="p-inputtext-lg"
                [(ngModel)]="data_field.value"
                placeholder="Add"
              />
            }
            @if (data_field?.field?.type === "number") {
              <p-inputNumber
                mode="decimal"
                inputId="withoutgrouping"
                [useGrouping]="false"
                [(ngModel)]="data_field.value"
                placeholder="Add"
              >
              </p-inputNumber>
            }
            @if (data_field?.field?.type === "date") {
              <p-datepicker
                [(ngModel)]="data_field.value"
                dateFormat="M dd, yy"
                [placeholder]="
                  data_field.value ? (data_field.value | date) : 'Add'
                "
                [showIcon]="true"
              ></p-datepicker>
            }
            @if (data_field?.field?.type === "list") {
              <p-dropdown
                [options]="data_field?.field?.select_options"
                [(ngModel)]="data_field.value"
                [showClear]="true"
                placeholder="Select an option"
              ></p-dropdown>
            }
            @if (data_field?.field?.type === "boolean") {
              <p-checkbox
                [(ngModel)]="data_field.value"
                [binary]="true"
                [trueValue]="'Yes'"
                [falseValue]="'No'"
                inputId="binary"
              ></p-checkbox>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (isForClientDetails) {
    <div class="main-section">
      <h3>Client Details</h3>
      <div class="fields-container">
        @for (data_field of clientDataFieldValues; track data_field) {
          <div class="field">
            <span>{{ data_field?.field?.name }}</span>
            @if (
              data_field?.field?.type !== "date" &&
              data_field?.field?.type !== "list" &&
              data_field?.field.type !== "boolean"
            ) {
              <input
                type="text"
                pInputText
                class="p-inputtext-lg"
                [(ngModel)]="data_field.value"
                [pattern]="
                  data_field?.field?.type === 'number' ? '^[0-9]*$' : '.*'
                "
              />
            }
            @if (data_field?.field?.type === "date") {
              <p-datepicker
                [(ngModel)]="data_field.value"
                dateFormat="M dd, yy"
                [placeholder]="
                  data_field.value ? (data_field.value | date) : 'Add'
                "
                [showIcon]="true"
              ></p-datepicker>
            }
            @if (data_field?.field?.type === "list") {
              <p-dropdown
                [options]="data_field?.field?.select_options"
                [(ngModel)]="data_field.value"
                [showClear]="true"
                placeholder="Select an option"
              ></p-dropdown>
            }
            @if (data_field?.field?.type === "boolean") {
              <p-checkbox
                [(ngModel)]="data_field.value"
                [binary]="true"
                inputId="binary"
              ></p-checkbox>
            }
          </div>
        }
      </div>
    </div>
  }
  <div class="footer">
    <hr style="height: 1px; color: #d7dbe1; width: 100%" />
    <div class="buttons-container">
      <button class="btn btn-default" (click)="closeDrawer()">Close</button>
      <button class="btn btn-primary" (click)="saveChanges()">
        Save changes
      </button>
    </div>
  </div>
</div>
